import { create } from './create'
import { deleteReport } from './delete'
import { getList } from './list'
import { getFormats } from './formats'
export default {
  create,
  deleteReport,
  getList,
  getFormats,
}
